import { lazy } from "react";

const ReleaseRequestPage = lazy(() => import("./ReleaseRequestPage"));

export { ReleaseRequestPage };
